"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertPassesToCreditsResponseToJSON = exports.ConvertPassesToCreditsResponseFromJSONTyped = exports.ConvertPassesToCreditsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function ConvertPassesToCreditsResponseFromJSON(json) {
    return ConvertPassesToCreditsResponseFromJSONTyped(json, false);
}
exports.ConvertPassesToCreditsResponseFromJSON = ConvertPassesToCreditsResponseFromJSON;
function ConvertPassesToCreditsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'conversionId': !(0, runtime_1.exists)(json, 'conversionId') ? undefined : json['conversionId'],
        'passesConverted': !(0, runtime_1.exists)(json, 'passesConverted') ? undefined : json['passesConverted'],
        'usdCredited': !(0, runtime_1.exists)(json, 'usdCredited') ? undefined : json['usdCredited'],
        'appliedRate': !(0, runtime_1.exists)(json, 'appliedRate') ? undefined : json['appliedRate'],
        'newTotalCredits': !(0, runtime_1.exists)(json, 'newTotalCredits') ? undefined : json['newTotalCredits'],
    };
}
exports.ConvertPassesToCreditsResponseFromJSONTyped = ConvertPassesToCreditsResponseFromJSONTyped;
function ConvertPassesToCreditsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'conversionId': value.conversionId,
        'passesConverted': value.passesConverted,
        'usdCredited': value.usdCredited,
        'appliedRate': value.appliedRate,
        'newTotalCredits': value.newTotalCredits,
    };
}
exports.ConvertPassesToCreditsResponseToJSON = ConvertPassesToCreditsResponseToJSON;
